export default __webpack_public_path__ + "static/media/arrow.062a4326.svg";